import Toast, { ToastProps } from "@/components/ui/Toast";
import { useCallback, useState } from "react";

type ToastOptions = Omit<ToastProps, "onClose">;

export function useToast() {
  const [toasts, setToasts] = useState<(ToastOptions & { id: string })[]>([]);

  const toast = useCallback((options: ToastOptions) => {
    const id = Math.random().toString(36).substring(2, 9);
    setToasts((prev) => [...prev, { ...options, id }]);
  }, []);

  const dismissToast = useCallback((id: string) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id));
  }, []);

  const Toaster = useCallback(() => {
    return (
      <>
        {toasts.map((toast) => (
          <Toast
            key={toast.id}
            title={toast.title}
            description={toast.description}
            variant={toast.variant}
            duration={toast.duration}
            onClose={() => dismissToast(toast.id)}
          />
        ))}
      </>
    );
  }, [toasts, dismissToast]);

  return { toast, Toaster };
}

export default useToast;
